import { API_BASE_URL } from "@/mocks/adminData";

export async function apiGet(path: string, token: string) {
  const res = await fetch(`${API_BASE_URL}/${path}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.json();
}

export async function apiPost(path: string, token: string, body: Record<string, unknown>) {
  const res = await fetch(`${API_BASE_URL}/${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });
  return res.json();
}

export const DEPT_OPTIONS = [
  { value: "promotion", label: "推广招商部" },
  { value: "third", label: "三方招商部" },
  { value: "investment", label: "招商部" },
];

export const getDeptLabel = (dept: string) =>
  DEPT_OPTIONS.find(d => d.value === dept)?.label || dept;
